module.exports = __webpack_public_path__ + "static/media/check-auth.46992484.svg";